import { Link as LinkRouter, LinkProps } from "react-router-dom";
import React from "react";

type Props = LinkProps;
export const Link: React.FC<Props> = (props) => {
  return (
    <LinkRouter
      {...props}
      style={{
        ...(props?.style ?? {}),
        textDecoration: "none",
        color: "black",
      }}
    />
  );
};
